export default "__VITE_ASSET__De1uZaWK__"